export default {
  title: 'Leveringsoplysninger',
  buttons: {
    save: 'Gem',
  },
};
